import React from "react";
import Modal from "react-responsive-modal";

class ActivityModal extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }
  onCloseModal = () => {
    window.location.href = "#/course_desc/" + this.props.course_id;
  };
  
  onLogout = () => {
    localStorage.clear();
    window.location.href = "#/"
    window.location.reload();
  };
  render() {
    const { open } = this.props;
    return (
      <Modal open={open} onClose={this.props.close} little>
        <div className="card card-style-3 border-0 text-center ">
        <div className="card-body new-quiz">
            <h3 className="font-weight-bold mb-3 text-primary">
              Activity Completed
            </h3>
            <hr />
            <h3 className="font-weight-bold mb-3">Any Feedback</h3>
            <p>Give us your valuable feedback to us.</p>
            <link to="" />
            <button
              type="button"
              className="btn btn-3 btn-primary btn-block text-2 font-weight-semibold"
              onClick={this.props.close}
            >
              Query 
            </button>
            <button
              type="button"
              className="btn btn-3 btn-reddit btn-block text-2 font-weight-semibold"
              onClick={this.onCloseModal}
            >
              No
            </button>        
          </div>
        </div>
      </Modal>
    );
  }
}

export default ActivityModal;
